import { API_PDC_URL_V1 } from "../../../config";

import { createHttpHeaderWithAuthorization } from "../../services/http-header";

import { overflowNotificationConstants } from "../overflowNotification";

import { callWithRetry } from "../../services/callWithRetry";

export const customersConstants = {
  GET_CUSTOMERS_LIST_START: "GET_CUSTOMERS_LIST_START",
  GET_CUSTOMERS_LIST_SUCCESS: "GET_CUSTOMERS_LIST_SUCCESS",
  GET_CUSTOMERS_LIST_ERROR: "GET_CUSTOMERS_LIST_ERROR",

  GET_CUSTOMERS_ACTIVATE_DBX_START: "GET_CUSTOMERS_ACTIVATE_DBX_START",
  GET_CUSTOMERS_ACTIVATE_DBX_SUCCESS: "GET_CUSTOMERS_ACTIVATE_DBX_SUCCESS",
  GET_CUSTOMERS_ACTIVATE_DBX_ERROR: "GET_CUSTOMERS_ACTIVATE_DBX_ERROR"
};

// 'https://pdc-server-api-dev.agyo.io/api/v1/onboarding/customers?managerId=8f039743-a364-40ef-931d-7afa1cbeb423' \

export function getCustomersList() {
  return (dispatch, getState) => {
    const auth = getState().auth;
    const accountantUuidSelected = getState().main.accountantUuidSelected;
    let request = {
      method: "get",
      url: API_PDC_URL_V1 + "/onboarding/customers?managerId=" + accountantUuidSelected,
      headers: createHttpHeaderWithAuthorization(auth.loginAuth.securityToken)
    };
    return new Promise(function(resolve, reject) {
      dispatch({
        type: customersConstants.GET_CUSTOMERS_LIST_START
      });
      callWithRetry(
        auth, request, dispatch
      )
        .then((result) => {
          if (result.status === 200) {
            dispatch({
              type: customersConstants.GET_CUSTOMERS_LIST_SUCCESS,
              payload: {
                list: result.data,
                accountantUuidSelected: accountantUuidSelected
              }
            });
          } else {
            dispatch({
              type: customersConstants.GET_CUSTOMERS_LIST_ERROR,
              error: result
            });
          }
          resolve(result.data);
        })
        .catch((response) => {
          dispatch({
            type: customersConstants.GET_CUSTOMERS_LIST_ERROR,
            error: response
          });
          reject();
        });
    });
  };
}

export function dbxActivate(args) {
  return (dispatch, getState) => {
    const auth = getState().auth;
    const user = getState().user;

    const bodyRequest = {
      managerId: args.accountantUuidSelected,
      itemId: args.clientIdSelected,
      connected: args.connected,
      subscribed: args.subscribed
    };
    let request = {
      method: "POST",
      url: `${API_PDC_URL_V1}/onboarding/customers/dbxActivate`,
      headers: {
        ...createHttpHeaderWithAuthorization(auth.loginAuth.securityToken)
      },
      data: bodyRequest
    };

    return new Promise(function(resolve, reject) {
      dispatch({
        type: customersConstants.GET_CUSTOMERS_ACTIVATE_DBX_START
      });

      callWithRetry(
        auth, request, dispatch
      )
        .then((result) => {
          dispatch({
            type: customersConstants.GET_CUSTOMERS_ACTIVATE_DBX_SUCCESS,
            payload: result.data
          });

          dispatch({
            type: overflowNotificationConstants.SHOW_OVERFLOW,
            payload: {
              type: "success",
              title: "OK",
              message: user?.profile?.language === "es-ES" ? "Hecho. La solicitud ha sido aceptada. Si el cliente sigue inactivo, comprueba que haya aceptado la invitación." : "Fatto. La richiesta è stata presa in carico. Se il cliente risulta ancora inattivo, controlla che abbia accettato la connessione."
            }
          });

          resolve(result.data);
        })
        .catch((response) => {
          dispatch({
            type: customersConstants.GET_CUSTOMERS_ACTIVATE_DBX_ERROR,
            error: response
          });
          reject(response);
        });
    });
  };
}
